import React from "react";
import { withStyles } from "@material-ui/core";

const styles = (theme) => ({
  moduleNotFound: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: "100%",
    fontWeight: 600,
    color: theme.iconColor,
  },
});

const ModuleNotFound = ({ classes }) => {
  return <div className={classes.moduleNotFound}>Module not found!</div>;
};

export default withStyles(styles)(ModuleNotFound);
